module.exports = __webpack_public_path__ + "static/media/analiza.c44d4eb7.png";